<template>
    <v-card width="100%" height="100%" outlined>
        <v-toolbar color="secondary" dark class="title" flat>
        <v-icon left>fas fa-boxes</v-icon>
            Small Group Resources
        </v-toolbar>
        <v-card-text>
            <v-row dense>
                <v-col cols="12" class="text-right">
                    <v-btn to="/Resources" outlined>
                        <v-icon left>fas fa-chevron-left</v-icon>
                        Back to List
                    </v-btn>
                </v-col>
            </v-row>
            <v-row dense class="body-1">
                <v-col cols="12" md="2" class="font-weight-bold">
                    TITLE:
                </v-col>
                <v-col cols="12" md="10">
                    {{getResource.title}}
                </v-col>
                <v-col cols="12" md="2" class="font-weight-bold">
                    AUTHOR:
                </v-col>
                <v-col cols="12" md="10">
                    {{getResource.author}}
                </v-col><v-col cols="12" md="2" class="font-weight-bold">
                    LINK:
                </v-col>
                <v-col cols="12" md="10">
                <v-btn outlined small v-if="getResource.link !== undefined && getResource.link !== ''" @click="goToLink(getResource.link)">
                    <v-icon left>fas fa-link</v-icon>
                    Resource Link
                </v-btn>
                    <span v-else>No link has been assigned</span>
                </v-col>
                <v-col cols="12" md="2" class="font-weight-bold">
                    DESCRIPTION:
                </v-col>
                <v-col cols="12" md="10">
                    {{getResource.description}}
                </v-col>
            </v-row>
            <v-row dense class="secondary lighten-5 body-1 pa-1" align="center">
                <v-col cols="12" class="font-weight-bold text-center text-md-left">AVAILABLE FORMATS:</v-col>
                <v-col cols="4">Audio:</v-col>
                <v-col cols="2">{{getResource.format.audio.count}}</v-col>
                <v-col cols="4">DVD:</v-col>
                <v-col cols="2">{{getResource.format.dvd.count}}</v-col>
                <v-col cols="4">Book:</v-col>
                <v-col cols="2">{{getResource.format.book.count}}</v-col>
                <v-col cols="4">Workbook:</v-col>
                <v-col cols="2">{{getResource.format.workbook.count}}</v-col>
                <v-col cols="4">Leader Guide:</v-col>
                <v-col cols="2">{{getResource.format.leaderGuide.count}}</v-col>
                <v-col cols="4">Online Video:</v-col>
                <v-col cols="2">{{getResource.format.onlineVideo.count}}</v-col>
            </v-row>
            <!-- <v-row>
                <v-col cols="12" class="text-right">
                <v-btn outlined>
                    <v-icon left>fas fa-envelope</v-icon>
                    Contact the Office about this resource
                </v-btn>
                </v-col>
            </v-row> -->
        </v-card-text>
    </v-card>
</template>
<script>
    export default {
        methods: {
            goToLink(url){
                window.open(url, "_blank")
            }
        },
        computed: {
            getResource(){
                let resourceId = this.$route.params.id   
                return this.$store.getters.getResources.filter(rec => rec.id == resourceId)[0]
            },
        }
    }
</script>